import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { libraryShape, paginationShape } from '@bibliocommons/bc-prop-types';

import { selectTagSummariesForCurrentBib, selectTagsPaginationForCurrentBib } from 'app/selectors/bibs/UgcSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { tagShape } from 'app/shapes/bibPage';
import CommunityTags from './CommunityTags';

export class CommunityTagsContainer extends React.PureComponent {
  render() {
    const { currentLibrary, metadataId, pagination, tags } = this.props;

    return (
      <CommunityTags currentLibrary={currentLibrary} metadataId={metadataId} pagination={pagination} tags={tags} />
    );
  }
}

CommunityTagsContainer.propTypes = {
  currentLibrary: libraryShape.isRequired,
  metadataId: PropTypes.string.isRequired,
  pagination: paginationShape,
  tags: ImmutablePropTypes.listOf(tagShape).isRequired
};

const mapStateToProps = state => ({
  currentLibrary: selectCurrentLibrary(state),
  tags: selectTagSummariesForCurrentBib(state),
  pagination: selectTagsPaginationForCurrentBib(state)
});

export default connect(mapStateToProps)(CommunityTagsContainer);
